module.exports = __webpack_public_path__ + "img/logo-site-acap82.f6add8aa.png";